import React from 'react';
import icon from '../../assets/images/email_icon.svg';

const MailIcon = () => <img src={icon} alt="Email Sent" />;

export default MailIcon;